// extracted by mini-css-extract-plugin
export default {"sidebarMenu":"Sidebar_sidebarMenu__JIOAC","active":"Sidebar_active__suNlm"};